module.exports = __webpack_public_path__ + "static/img/13.4c12598.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/t-carousel/13.jpg
// module id = wWGb
// module chunks = 1